<template>
  <picture class="player-image">
    <img :src="src" @error="onError">
  </picture>
</template>

<script>
export default {
  props: {
    player: Object,
  },

  data() {
    return {
      src: null,
    };
  },

  created() {
    this.setImgSrc();
  },

  watch: {
    player: {
      handler() {
        this.setImgSrc();
      },
      deep: true,
    },
  },

  methods: {
    setImgSrc() {
      if (this.player) {
        this.src = `https://s3.amazonaws.com/firstandfive/assets/playerimages/${this.player.id}.jpg`;
      }
    },

    onError() {
      this.src = 'https://s3.amazonaws.com/firstandfive/assets/playerimages/player-placeholder.jpg';
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  picture {
    display: block;

    position: relative;
    height: 0;
    width: 100%;
    padding-top: 61.77%;
    background: transparent;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
